import React, { useState, useEffect } from "react";
import { auth, database, firebaseConfig } from "../../config/firebase";
import { useAuth } from "../../contexts/AuthContext";
import {
  getDatabase,
  ref,
  push,
  onValue,
  get,
  child,
  set,
  query,
  orderByChild,
  equalTo,
} from "firebase/database";
import "./PaymentTransfer.css";

export default function PaymentTransfer() {
  const [loading, setLoading] = useState(false);
  const expayAPIUrl = firebaseConfig.expayApiUrl;
  const { currentUser, updateUserProfile, setError } = useAuth();

  // Transaction history
const [etransferHistory, setEtransferHistory] = useState([]);
const [billPaymentHistory, setBillPaymentHistory] = useState([]);



  // Step management
  const [currentStep, setCurrentStep] = useState("selectType");
  const [paymentType, setPaymentType] = useState("");
  
  // Identity verification
  const [verificationType, setVerificationType] = useState("");
  const [verificationInput, setVerificationInput] = useState("");
  const [verificationError, setVerificationError] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  
  // Interac transfer fields
  const [recipientName, setRecipientName] = useState("");
  const [recipientContact, setRecipientContact] = useState("");
  const [contactType, setContactType] = useState("email");
  const [amount, setAmount] = useState("");
  const [ddrStatus, setDdrStatus] = useState(null);
  const [ddrName, setDdrName] = useState("");
  const [securityQuestion, setSecurityQuestion] = useState("");
  const [securityAnswer, setSecurityAnswer] = useState("");
  
  // Bill payment fields
  const [payeeSearch, setPayeeSearch] = useState("");
  const [payeeOptions, setPayeeOptions] = useState([]);
  const [selectedPayee, setSelectedPayee] = useState(null);
  const [billAmount, setBillAmount] = useState("");
  const [PayeeAccountNumber, setPayeeAccountNumber] = useState("");
  
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  
  // Errors
  const [nameError, setNameError] = useState("");
  const [contactError, setContactError] = useState("");
  const [amountError, setAmountError] = useState("");
  const [PayeeAccountNumberError, setPayeeAccountNumberError] = useState("");
  const [questionError, setQuestionError] = useState("");
  const [answerError, setAnswerError] = useState("");
const [permissionError, setPermissionError] = useState("");

  useEffect(() => {
    const types = ["year"];
    const randomType = types[Math.floor(Math.random() * types.length)];
    setVerificationType(randomType);
      if (currentUser) fetchHistory();

  }, [currentUser]);


const fetchHistory = async () => {
  if (!currentUser?.uid) return;
  try {
    const db = getDatabase();

    // Interac e-Transfer history
    const etransferRef = ref(db, `${firebaseConfig.dataPath}${currentUser.uid}/history/etransfer`);
    const etransferSnapshot = await get(etransferRef);
    if (etransferSnapshot.exists()) {
      const data = etransferSnapshot.val();
      const historyArray = Object.entries(data)
        .map(([key, value]) => ({ id: key, ...value }))
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)); // latest first
      setEtransferHistory(historyArray);
    }

    // Bill payment history
    const billRef = ref(db, `${firebaseConfig.dataPath}${currentUser.uid}/history/billpayment`);
    const billSnapshot = await get(billRef);
    if (billSnapshot.exists()) {
      const data = billSnapshot.val();
      const historyArray = Object.entries(data)
        .map(([key, value]) => ({ id: key, ...value }))
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      setBillPaymentHistory(historyArray);
    }
  } catch (error) {
    console.error("Failed to fetch history:", error);
  }
};


const cleanObject = (obj) => {
  if (typeof obj !== "object" || obj === null) return obj;
  const cleaned = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined) cleaned[key] = cleanObject(value);
  }
  return cleaned;
};

const saveLog = async (uid, type, action, requestData, responseData, success) => {
  try {
    const db = getDatabase();
    const timestamp = new Date().toISOString();
    const userEmail = currentUser?.email || "unknown";

    const cleanedRequest = cleanObject(requestData);
    const cleanedResponse = cleanObject(responseData);

    if (["sendETransfer", "sendBill"].includes(action)) {
      const historyRef = ref(db, `${firebaseConfig.dataPath}${uid}/history/${type}`);
      await push(historyRef, {
        requestData: cleanedRequest,
        responseData: cleanedResponse,
        success: !!success,
        timestamp,
      });
    }
  } catch (err) {
    console.error("Failed to save log:", err);
  }
};


  // API: Check DDR status
  const checkDDRStatus = async (contact) => {
    setLoading(true);
    try {
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      if (!snapshot.exists()) {
        await saveLog(currentUser.uid, "etransfer", "checkDDR", { contact }, { error: "User data not found" }, false);
        return;
      }
      
      const payload = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(contact)) {
        payload.Email = contact;
      } else {
        payload.Phone = contact.replace(/\D/g, '');
      }
    
      const token = await currentUser.getIdToken();
      const response = await fetch(expayAPIUrl + "/checkAD", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ apiKey: "YOUR_API_KEY", payload }),
      });
      
      const data = await response.json();
      await saveLog(currentUser.uid, "etransfer", "checkDDR", { contact }, data, data.AD ? true : false);

      setDdrStatus(data.AD ? true : false);
      setDdrName(data.AD ? (data.name || "Recipient") : "");

    } catch (error) {
      console.error("Error checking DDR:", error);
      setDdrStatus(false);
      await saveLog(currentUser.uid, "etransfer", "checkDDR", { contact }, { error: error.message }, false);
    } finally {
      setLoading(false);
    }
  };

// ✅ API: Search payees — min 4 characters required
const searchPayees = async (searchTerm) => {
  if (!searchTerm || searchTerm.trim().length < 4) {
    setPayeeOptions([]);
    return;
  }

  setLoading(true);
  try {
    const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
    const snapshot = await get(usersRef);
    if (!snapshot.exists()) {
      setPayeeOptions([]);
      await saveLog(
        currentUser.uid,
        "billpayment",
        "searchPayees",
        { searchTerm },
        { error: "User data not found" },
        false
      );
      return;
    }

    const token = await currentUser.getIdToken();
    const response = await fetch(expayAPIUrl + "/getPayee", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        apiKey: "YOUR_API_KEY",
        payload: { Name: searchTerm }
      }),
    });

    const data = await response.json();

    if (data.IsSucceeded && Array.isArray(data.Item)) {
      const formattedPayees = data.Item.map((payee, index) => ({
        id: index + 1,
        name: payee.PayeeName,
        payeeCode: payee.PayeeCode,
      }));

      setPayeeOptions(formattedPayees);
      await saveLog(
        currentUser.uid,
        "billpayment",
        "searchPayees",
        { searchTerm },
        { payeesFound: formattedPayees.length },
        true
      );
    } else {
      setPayeeOptions([]);
      await saveLog(
        currentUser.uid,
        "billpayment",
        "searchPayees",
        { searchTerm },
        data,
        false
      );
    }
  } catch (error) {
    console.error("Error searching payees:", error);
    setPayeeOptions([]);
    await saveLog(
      currentUser.uid,
      "billpayment",
      "searchPayees",
      { searchTerm },
      { error: error.message },
      false
    );
  } finally {
    setLoading(false);
  }
};


  // API: Send Interac transfer
  const sendInteracTransfer = async () => {
    setLoading(true);
    try {
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (!snapshot.exists()) {
        const errorResponse = {
          success: false,
          message: "User data not found. Please try again.",
        };
        setApiResponse(errorResponse);
        await saveLog(currentUser.uid, "etransfer", "sendETransfer", {}, { error: "User data not found" }, false);
        setCurrentStep("result");
        return;
      }

      const userData = snapshot.val();
      const payload = {
        customerName: recipientName,
        customerNum: userData.customerNum,
        amount: parseFloat(amount),
        description: ""
      };
      
      if (contactType === "email") {
        payload.email = recipientContact;
      } else {
        payload.phoneNumber = recipientContact.replace(/\D/g, '');
        payload.phoneCountryCode = "1";
      }
      
      if (ddrStatus === false) {
        payload.securityQuestion = securityQuestion;
        payload.securityQuestionAnswer = securityAnswer;
      }
      
      const token = await currentUser.getIdToken();
      const response = await fetch(expayAPIUrl + "/sendETransfer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ apiKey: "YOUR_API_KEY", ...payload }),
      });
      
      const data = await response.json();

      await saveLog(
        currentUser.uid,
        "etransfer",
        "sendETransfer",
        payload,
        data,
        data.success || false
      );

      setApiResponse({
        success: data.success || false,
        message: data.success ? (data.message || "e-Transfer sent successfully!") : (data.error || "Failed to send e-Transfer."),
        referenceNumber: data.referenceNumber,
      });
      
      setCurrentStep("result");
    } catch (error) {
      console.error("Error sending e-Transfer:", error);
      const errorResponse = {
        success: false,
        message: "Failed to send e-Transfer. Please try again.",
      };
      setApiResponse(errorResponse);
      await saveLog(currentUser.uid, "etransfer", "sendETransfer", { recipientName, recipientContact, amount }, { error: error.message }, false);
      setCurrentStep("result");
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  // API: Send bill payment
 // ✅ Updated API: Send bill payment using ExPay API
const sendBill = async () => {
  setLoading(true);
  try {
    const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
    const snapshot = await get(usersRef);
    
    if (!snapshot.exists()) {
      const errorResponse = {
        success: false,
        message: "User data not found. Please try again.",
      };
      setApiResponse(errorResponse);
      await saveLog(currentUser.uid, "billpayment", "sendBill", {}, errorResponse, false);
      setCurrentStep("result");
      return;
    }

    const userData = snapshot.val();
    const token = await currentUser.getIdToken();

    const payload = {
      CustomerNumber: userData.customerNum,
      PayeeCode: selectedPayee?.payeeCode,
      PayeeName: selectedPayee?.name, // ✅ include PayeeName
      AccountNumber: PayeeAccountNumber,
      Amount: parseFloat(billAmount),
    };

    const response = await fetch(`${expayAPIUrl}/sendBill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        apiKey: "YOUR_API_KEY",
        payload,
      }),
    });

    const data = await response.json();

    const success = data.IsSucceeded || data.success;
    const result = {
      success,
      message: success
        ? data.Message || "Bill payment processed successfully!"
        : data.ErrorMessage || data.Message || "Failed to process bill payment.",
      referenceNumber: data.ReferenceNumber || data.TransactionID || null,
    };

    setApiResponse(result);

    await saveLog(
      currentUser.uid,
      "billpayment",
      "sendBill",
      payload,
      data,
      success
    );

    setCurrentStep("result");
  } catch (error) {
    console.error("Error sending bill payment:", error);
    const errorResponse = {
      success: false,
      message: "Failed to process bill payment. Please try again.",
    };
    setApiResponse(errorResponse);
    await saveLog(
      currentUser.uid,
      "billpayment",
      "sendBill",
      { selectedPayee, PayeeAccountNumber, billAmount },
      { error: error.message },
      false
    );
    setCurrentStep("result");
  } finally {
    setLoading(false);
    setShowModal(false);
  }
};


  const handleVerification = async () => {
    setVerificationError("");
    setLoading(true);
    
    try {
      const token = await currentUser.getIdToken();
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const requestData = {
          CustomerNumber: userData.customerNum,
          verificationType,
          verificationInputLength: verificationInput.length
        };
        
        const response = await fetch(`${expayAPIUrl}/verifyUser`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: {
              CustomerNumber: userData.customerNum,
              verificationInput: verificationInput
            },
          }),
        });
        
        const apiResponse = await response.json();
        
        if (apiResponse.verified === true || apiResponse.ErrorCode === "0") {
          setIsVerified(true);
          setCurrentStep("form");
          await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", requestData, { verified: true }, true);
        } else {

          
          setVerificationError(apiResponse.message || "Year of birth does not match our records");
          await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", requestData, apiResponse, false);
        }
      } else {
        setVerificationError("User data not found. Please try again.");
        await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", { verificationType }, { error: "User data not found" }, false);
      }
    } catch (error) {
      console.error("Verification error:", error);
      setVerificationError("Unable to verify. Please try again later.");
      await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", { verificationType }, { error: error.message }, false);
    } finally {
      setLoading(false);
    }
  };

    const handleVerification1 = async () => {
    setVerificationError("");
    setLoading(true);
    
    try {
      const token = await currentUser.getIdToken();
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const requestData = {
          CustomerNumber: userData.customerNum,
          verificationType,
          verificationInputLength: verificationInput.length
        };
        
        const response = await fetch(`${expayAPIUrl}/verifyUser1`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: {
              CustomerNumber: userData.customerNum,
              verificationInput: verificationInput
            },
          }),
        });
        
        const apiResponse = await response.json();
        
        if (apiResponse.verified === true || apiResponse.ErrorCode === "0") {
          setIsVerified(true);
          setCurrentStep("form");
          await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", requestData, { verified: true }, true);
        } else {
          setVerificationError(apiResponse.message || "Year of birth does not match our records");
          await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", requestData, apiResponse, false);
        }
      } else {
        setVerificationError("User data not found. Please try again.");
        await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", { verificationType }, { error: "User data not found" }, false);
      }
    } catch (error) {
      console.error("Verification error:", error);
      setVerificationError("Unable to verify. Please try again later.");
      await saveLog(currentUser.uid, paymentType || "verification", "verifyIdentity", { verificationType }, { error: error.message }, false);
    } finally {
      setLoading(false);
    }
  };
  const handleContactBlur = async () => {
    if (recipientContact && contactType === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(recipientContact)) {
        await checkDDRStatus(recipientContact);
      }
    } else if (recipientContact && contactType === "phone") {
      const phoneRegex = /^\d{10}$/;
      if (phoneRegex.test(recipientContact.replace(/\D/g, ""))) {
        await checkDDRStatus(recipientContact);
      }
    }
  };

  const validateInteracForm = () => {
    let isValid = true;
    const errors = {};
    
    setNameError("");
    setContactError("");
    setAmountError("");
    setQuestionError("");
    setAnswerError("");
    
    if (!recipientName.trim()) {
      setNameError("Recipient name is required");
      errors.name = "Recipient name is required";
      isValid = false;
    }
    
    if (contactType === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(recipientContact)) {
        setContactError("Please enter a valid email address");
        errors.contact = "Invalid email";
        isValid = false;
      }
    } else {
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(recipientContact.replace(/\D/g, ""))) {
        setContactError("Please enter a valid 10-digit phone number");
        errors.contact = "Invalid phone";
        isValid = false;
      }
    }
    
    if (!amount || parseFloat(amount) <= 0) {
      setAmountError("Please enter a valid amount");
      errors.amount = "Invalid amount";
      isValid = false;
    }
    
    if (ddrStatus === false) {
      if (!securityQuestion.trim()) {
        setQuestionError("Security question is required");
        errors.securityQuestion = "Required";
        isValid = false;
      }
      if (!securityAnswer.trim()) {
        setAnswerError("Security answer is required");
        errors.securityAnswer = "Required";
        isValid = false;
      }
    }
    
    // Log validation attempt
    saveLog(
      currentUser.uid,
      "etransfer",
      "validateForm",
      { contactType, hasRecipient: !!recipientName, hasAmount: !!amount, ddrStatus },
      { isValid, errors },
      isValid
    );
    
    return isValid;
  };

  const validateBillPayment = () => {
    let isValid = true;
    const errors = {};
    
    setAmountError("");
    setPayeeAccountNumberError("");
    
    if (!selectedPayee) {
      errors.payee = "No payee selected";
      return false;
    }
    
    if (!billAmount || parseFloat(billAmount) <= 0) {
      setAmountError("Please enter a valid amount");
      errors.amount = "Invalid amount";
      isValid = false;
    }

    if (!PayeeAccountNumber) {
      setPayeeAccountNumberError("Please enter a valid Account Number");
      errors.accountNumber = "Required";
      isValid = false;
    }
    
    // Log validation attempt
    saveLog(
      currentUser.uid,
      "billpayment",
      "validateForm",
      { hasPayee: !!selectedPayee, hasAmount: !!billAmount, hasAccountNumber: !!PayeeAccountNumber },
      { isValid, errors },
      isValid
    );
    
    return isValid;
  };

  const handleInteracContinue = () => {
    if (validateInteracForm()) {
      setShowModal(true);
      saveLog(currentUser.uid, "etransfer", "openConfirmationModal", { recipientName, amount }, {}, true);
    }
  };

  const handleBillPaymentContinue = () => {
    if (validateBillPayment()) {
      setShowModal(true);
      saveLog(currentUser.uid, "billpayment", "openConfirmationModal", { payee: selectedPayee?.name, billAmount }, {}, true);
    }
  };

  const handleCancel = () => {
    saveLog(currentUser.uid, paymentType || "general", "cancelTransaction", { currentStep, paymentType }, {}, true);
    
    setCurrentStep("selectType");
    setPaymentType("");
    setIsVerified(false);
    setVerificationInput("");
    setRecipientName("");
    setRecipientContact("");
    setAmount("");
    setDdrStatus(null);
    setSecurityQuestion("");
    setSecurityAnswer("");
    setPayeeSearch("");
    setSelectedPayee(null);
    setBillAmount("");
    setPayeeAccountNumber("");
    setApiResponse(null);
  };

  const handlePaymentSelection = async (type) => {
    setPermissionError("");
    if (!currentUser) return;

    try {
      // Force refresh to ensure claims are up to date, or use false if cached is okay
      const tokenResult = await currentUser.getIdTokenResult(); 
      
      if (type === "interac") {
        if (tokenResult.claims.INT) {
          setPaymentType("interac");
          setCurrentStep("verify");
          saveLog(currentUser.uid, "etransfer", "selectPaymentType", { type: "interac" }, {}, true);
        } else {
          setPermissionError("You are not authorized to use Interac e-Transfer.");
        }
      } else if (type === "bill") {
        if (tokenResult.claims.BIL) {
          setPaymentType("bill");
          setCurrentStep("verify1");
          saveLog(currentUser.uid, "billpayment", "selectPaymentType", { type: "bill" }, {}, true);
        } else {
          setPermissionError("You are not authorized to use Bill Payment.");
        }
      }
    } catch (error) {
      console.error("Error checking permissions:", error);
      setPermissionError("Failed to verify permissions. Please try again.");
    }
  };

const renderSelectType = () => (
    <div className="payment-options">
      {/* Display permission error if access is denied */}
      {permissionError && (
        <div className="alert alert-warning" style={{ marginBottom: "1rem", width: "100%" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
            <line x1="12" y1="8" x2="12" y2="12" strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <span>{permissionError}</span>
        </div>
      )}

      <button
        onClick={() => handlePaymentSelection("interac")}
        className="payment-option-btn interac"
      >
        <div className="option-icon">💸</div>
        <div className="option-content">
          <h3>Interac e-Transfer</h3>
          <p>Send money instantly via email or phone</p>
        </div>
        <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M9 18l6-6-6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <button
        onClick={() => handlePaymentSelection("bill")}
        className="payment-option-btn bill"
      >
        <div className="option-icon">💳</div>
        <div className="option-content">
          <h3>Bill Payment</h3>
          <p>Pay bills to registered payees</p>
        </div>
        <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M9 18l6-6-6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );

  const renderVerification = () => (
    <div className="payment-card">
      <div className="card-header">
        <h2>Verify Identity</h2>
        <p>Please confirm your identity to continue</p>
      </div>
      <div className="form-content">
        <div className="form-group">
          <label>
            {verificationType === "year" 
              ? "Year of Birth" 
              : "Last 4 Digits of Card"}
          </label>
          <input
            type="text"
            value={verificationInput}
            onChange={(e) => setVerificationInput(e.target.value)}
            maxLength={4}
            placeholder={verificationType === "year" ? "YYYY" : "••••"}
            className={verificationError ? "error" : ""}
          />
          {verificationError && <span className="error-message">{verificationError}</span>}
        </div>
        <div className="button-group">
          <button
            onClick={handleVerification}
            disabled={loading}
            className="btn-primary"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Verifying...
              </>
            ) : "Verify"}
          </button>
          <button onClick={handleCancel} className="btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

    const renderVerification1 = () => (
    <div className="payment-card">
      <div className="card-header">
        <h2>Verify Identity</h2>
        <p>Please confirm your identity to continue</p>
      </div>
      <div className="form-content">
        <div className="form-group">
          <label>
            {verificationType === "year" 
              ? "Year of Birth" 
              : "Last 4 Digits of Card"}
          </label>
          <input
            type="text"
            value={verificationInput}
            onChange={(e) => setVerificationInput(e.target.value)}
            maxLength={4}
            placeholder={verificationType === "year" ? "YYYY" : "••••"}
            className={verificationError ? "error" : ""}
          />
          {verificationError && <span className="error-message">{verificationError}</span>}
        </div>
        <div className="button-group">
          <button
            onClick={handleVerification1}
            disabled={loading}
            className="btn-primary"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Verifying...
              </>
            ) : "Verify"}
          </button>
          <button onClick={handleCancel} className="btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  const renderInteracForm = () => (
    <div className="payment-card">
      <div className="card-header">
        <h2>Interac e-Transfer</h2>
        <p>Send money to anyone in Canada</p>
      </div>
      <div className="form-content">
        <div className="form-group">
          <label>Recipient Name</label>
          <input
            type="text"
            value={recipientName}
            onChange={(e) => setRecipientName(e.target.value)}
            placeholder="Enter recipient's full name"
            className={nameError ? "error" : ""}
          />
          {nameError && <span className="error-message">{nameError}</span>}
        </div>

        <div className="form-group">
          <label>Contact Method</label>
          <select
            value={contactType}
            onChange={(e) => {
              setContactType(e.target.value);
              setRecipientContact("");
              setDdrStatus(null);
              saveLog(currentUser.uid, "etransfer", "changeContactMethod", { contactType: e.target.value }, {}, true);
            }}
          >
            <option value="email">Email Address</option>
            <option value="phone">Phone Number</option>
          </select>
        </div>

        <div className="form-group">
          <label>{contactType === "email" ? "Email Address" : "Phone Number"}</label>
          <input
            type={contactType === "email" ? "email" : "tel"}
            value={recipientContact}
            onChange={(e) => setRecipientContact(e.target.value)}
            onBlur={handleContactBlur}
            placeholder={contactType === "email" ? "recipient@example.com" : "(123) 456-7890"}
            className={contactError ? "error" : ""}
          />
          {contactError && <span className="error-message">{contactError}</span>}
        </div>

        {ddrStatus === true && (
          <div className="alert alert-success">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" strokeWidth="2" strokeLinecap="round"/>
              <polyline points="22 4 12 14.01 9 11.01" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <div>
              <strong>Autodeposit Enabled</strong>
              <p>Recipient: {ddrName}</p>
            </div>
          </div>
        )}

        {ddrStatus === false && (
          <>
            <div className="alert alert-warning">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" strokeWidth="2" strokeLinecap="round"/>
                <line x1="12" y1="9" x2="12" y2="13" strokeWidth="2" strokeLinecap="round"/>
                <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <div>
                <strong>Security Question Required</strong>
                <p>Autodeposit not enabled for this recipient</p>
              </div>
            </div>
            <div className="form-group">
              <label>Security Question</label>
              <input
                type="text"
                value={securityQuestion}
                onChange={(e) => setSecurityQuestion(e.target.value)}
                placeholder="e.g., What is your favorite color?"
                className={questionError ? "error" : ""}
              />
              {questionError && <span className="error-message">{questionError}</span>}
            </div>
            <div className="form-group">
              <label>Security Answer</label>
              <input
                type="text"
                value={securityAnswer}
                onChange={(e) => setSecurityAnswer(e.target.value)}
                placeholder="Enter the answer"
                className={answerError ? "error" : ""}
              />
              {answerError && <span className="error-message">{answerError}</span>}
            </div>
          </>
        )}

        <div className="form-group">
          <label>Amount</label>
          <div className="input-with-icon">
            <span className="input-icon">$</span>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0.00"
              className={amountError ? "error with-icon" : "with-icon"}
            />
          </div>
          {amountError && <span className="error-message">{amountError}</span>}
        </div>

        <div className="button-group">
          <button
            onClick={handleInteracContinue}
            disabled={loading}
            className="btn-primary"
          >
            Continue
          </button>
          <button onClick={handleCancel} className="btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  const renderBillPaymentForm = () => (
    <div className="payment-card">
      <div className="card-header">
        <h2>Bill Payment</h2>
        <p>Pay your bills easily and securely</p>
      </div>
      <div className="form-content">
        <div className="form-group">
          <label>Search Payee (min 4 characters)</label>
          <div className="search-container">
            <input
              type="text"
              value={payeeSearch}
              onChange={(e) => {
                setPayeeSearch(e.target.value);
                searchPayees(e.target.value);
              }}
              placeholder="Start typing payee name..."
            />
            {payeeOptions.length > 0 && (
              <div className="search-dropdown">
                {payeeOptions.map((payee) => (
                  <button
                    key={payee.id}
                    type="button"
                    onClick={() => {
                      setSelectedPayee(payee);
                      setPayeeSearch(payee.name);
                      setPayeeOptions([]);
                      saveLog(currentUser.uid, "billpayment", "selectPayee", { payee }, {}, true);
                    }}
                    className="dropdown-item"
                  >
                    <div>
                      <strong>{payee.name}</strong>
                      <span>{payee.payeeCode}</span>
                    </div>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline points="9 18 15 12 9 6" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {selectedPayee && (
          <div className="alert alert-info">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="10" strokeWidth="2"/>
              <line x1="12" y1="16" x2="12" y2="12" strokeWidth="2" strokeLinecap="round"/>
              <line x1="12" y1="8" x2="12.01" y2="8" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <div>
              <strong>{selectedPayee.name}</strong>
              <p>Payee Code: {selectedPayee.payeeCode}</p>
            </div>
          </div>
        )}

        <div className="form-group">
          <label>Account Number</label>
          <input
            type="text"
            value={PayeeAccountNumber}
            onChange={(e) => setPayeeAccountNumber(e.target.value)}
            placeholder="Enter account number"
            disabled={!selectedPayee}
            className={PayeeAccountNumberError ? "error" : ""}
          />
          {PayeeAccountNumberError && <span className="error-message">{PayeeAccountNumberError}</span>}
        </div>

        <div className="form-group">
          <label>Amount</label>
          <div className="input-with-icon">
            <span className="input-icon">$</span>
            <input
              type="number"
              value={billAmount}
              onChange={(e) => setBillAmount(e.target.value)}
              placeholder="0.00"
              disabled={!selectedPayee}
              className={amountError ? "error with-icon" : "with-icon"}
            />
          </div>
          {amountError && <span className="error-message">{amountError}</span>}
        </div>

        <div className="button-group">
          <button
            onClick={handleBillPaymentContinue}
            disabled={loading || !selectedPayee}
            className="btn-primary"
          >
            Continue
          </button>
          <button onClick={handleCancel} className="btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  const renderModal = () => {
    if (!showModal) return null;

    return (
      <div className="modal-overlay" onClick={() => !loading && setShowModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Confirm Payment</h3>
            <button 
              className="modal-close" 
              onClick={() => {
                setShowModal(false);
                saveLog(currentUser.uid, paymentType, "closeConfirmationModal", {}, {}, true);
              }}
              disabled={loading}
            >
              ×
            </button>
          </div>
          
          <div className="modal-body">
            {paymentType === "interac" ? (
              <div className="confirmation-details">
                <div className="detail-row">
                  <span>Recipient</span>
                  <strong>{recipientName}</strong>
                </div>
                <div className="detail-row">
                  <span>Contact</span>
                  <strong>{recipientContact}</strong>
                </div>
                <div className="detail-row">
                  <span>Amount</span>
                  <strong className="amount">${parseFloat(amount).toFixed(2)}</strong>
                </div>
                {ddrStatus === false && (
                  <>
                    <div className="detail-row">
                      <span>Security Question</span>
                      <strong>{securityQuestion}</strong>
                    </div>
                    <div className="detail-row">
                      <span>Answer</span>
                      <strong>{securityAnswer}</strong>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="confirmation-details">
                <div className="detail-row">
                  <span>Payee</span>
                  <strong>{selectedPayee?.name}</strong>
                </div>
                <div className="detail-row">
                  <span>Account</span>
                  <strong>{PayeeAccountNumber}</strong>
                </div>
                <div className="detail-row">
                  <span>Amount</span>
                  <strong className="amount">${parseFloat(billAmount).toFixed(2)}</strong>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button
              onClick={paymentType === "interac" ? sendInteracTransfer : sendBill}
              disabled={loading}
              className="btn-primary"
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Processing...
                </>
              ) : "Confirm & Send"}
            </button>
            <button
              onClick={() => {
                setShowModal(false);
                saveLog(currentUser.uid, paymentType, "cancelConfirmation", {}, {}, true);
              }}
              disabled={loading}
              className="btn-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

 const renderHistory = () => (
  <div className="history-section">
    <h2>Transaction History</h2>

    {/* Interac e-Transfers */}
    <div className="history-category">
      <h3>Interac e-Transfers</h3>
      {etransferHistory.length === 0 ? (
        <div className="history-empty">
          <p>No e-Transfers yet.</p>
        </div>
      ) : (
        <ul className="history-list">
          {etransferHistory.map((item) => (
            <li key={item.id} className="history-item">
              <div className="history-item-left">
                <div className="history-item-name">
                  {item.requestData?.customerName || "Unknown Recipient"}
                </div>
                <div className="history-item-details">
                  <span>{item.requestData?.email || item.requestData?.phoneNumber || "N/A"}</span>
                  <span>•</span>
                  <span className="history-item-date">
                    {new Date(item.timestamp).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
              </div>
              <div className="history-item-right">
                <span className="history-item-amount">
                  ${item.requestData?.amount?.toFixed(2) || "0.00"}
                </span>
                <span className={`history-item-status ${item.success ? 'success' : 'failed'}`}>
                  {item.success ? 'Success' : 'Failed'}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>

    {/* Bill Payments */}
    <div className="history-category">
      <h3>Bill Payments</h3>
      {billPaymentHistory.length === 0 ? (
        <div className="history-empty">
          <p>No bill payments yet.</p>
        </div>
      ) : (
        <ul className="history-list">
          {billPaymentHistory.map((item) => (
            <li key={item.id} className="history-item">
              <div className="history-item-left">
                <div className="history-item-name">
                  {item.requestData?.PayeeName || "Unknown Payee"}
                </div>
                <div className="history-item-details">
                  <span>Account: {item.requestData?.AccountNumber || "N/A"}</span>
                  <span>•</span>
                  <span className="history-item-date">
                    {new Date(item.timestamp).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
              </div>
              <div className="history-item-right">
                <span className="history-item-amount">
                  ${item.requestData?.Amount?.toFixed(2) || "0.00"}
                </span>
                <span className={`history-item-status ${item.success ? 'success' : 'failed'}`}>
                  {item.success ? 'Success' : 'Failed'}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

  const renderResult = () => {
    if (!apiResponse) return null;

    return (
      <div className="payment-card">
        <div className={`result-container ${apiResponse.success ? 'success' : 'error'}`}>
          <div className="result-icon">
            {apiResponse.success ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" strokeWidth="2" strokeLinecap="round"/>
                <polyline points="22 4 12 14.01 9 11.01" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                <line x1="15" y1="9" x2="9" y2="15" strokeWidth="2" strokeLinecap="round"/>
                <line x1="9" y1="9" x2="15" y2="15" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            )}
          </div>
          <h3>{apiResponse.success ? 'Payment Successful!' : 'Payment Failed'}</h3>
          <p>{apiResponse.message}</p>
          {apiResponse.success && apiResponse.referenceNumber && (
            <div className="reference-number">
              <span>Reference Number</span>
              <strong>{apiResponse.referenceNumber}</strong>
            </div>
          )}
        </div>
        <button onClick={handleCancel} className="btn-primary">
          Make Another Payment
        </button>
      </div>
    );
  };

 return (
    <div className="payment-transfer-container">
      <div className="payment-transfer-wrapper">
        {currentStep === "selectType" && (
          <>
            {renderSelectType()}
            {renderHistory()}
          </>
        )}
        {currentStep === "verify" && renderVerification()}
        {currentStep === "verify1" && renderVerification1()}
        {currentStep === "form" && paymentType === "interac" && renderInteracForm()}
        {currentStep === "form" && paymentType === "bill" && renderBillPaymentForm()}
        {currentStep === "result" && renderResult()}
        {renderModal()}
      </div>
    </div>
  );
}